import { ProductSku, Stack, Text, useText } from "@sveabank/cc-common";
import { useParams } from "react-router";
import { useFetchClcSelectedPackageQuery } from "../../services/clc-application";

export const FreeCertificateText = () => {
	const [t, texts] = useText();

	const { applicationId } = useParams();
	var selectedPackage = undefined;

	if (applicationId) {
		const { data } = useFetchClcSelectedPackageQuery(applicationId);
		selectedPackage = data;
	}

	const hasFeeCertificate = selectedPackage?.products?.some(
		(product) => product.sku === ProductSku.BankCertificateFee,
	);

	if (hasFeeCertificate)
		return <Text align="start">{t(texts.newCompany.processModalInfoText2)}</Text>;

	return (
		<Stack gap={1} direction="row">
			<Text align="start">
				{t(texts.dashboardPage.campaign.content)} (
				<span className="sr-only">{t(texts.dashboardPage.campaign.regularPrice)} </span>
				<s>1 995 kr</s>{" "}
				<span className="text-text-alert font-bold">
					{t(texts.dashboardPage.campaign.currentPrice)}
				</span>
				).
			</Text>
		</Stack>
	);
};
